import { Store } from '@ngxs/store';
import { StepEnum } from '../tool-preautorisation/experimente/constants/step.enum';
import { PreautorisationModel } from '../tool-preautorisation/experimente/models/preautorisation.model';
import { PreautorisationSelectors } from '../tool-preautorisation/experimente/state/preautorisation.selectors';
import {
  GoToStep,
  NavigatePageAccueil,
  NavigatePageFormulaire,
  NavigatePageNonEligible,
  NavigatePageResultat,
  PatchDebug,
  SaveEtapeConsentement,
  Submit,
  ValiderPreadmissibilite
} from '../tool-preautorisation/experimente/state/preautorisation.actions';
import { AppConfigService } from '../app-config.service';
import { DonneReferenceService } from '../shared/services/donne-reference.service';

export class TestAutomatisePreautorisation {
  constructor(private readonly store: Store, private readonly appConfig: AppConfigService) {}

  allerEtape(etape: string) {
    console.log('TestHelper > preautorisation > allerPage', etape);
    if (StepEnum[etape]) {
      this.store.dispatch(new GoToStep(StepEnum[etape]));
      this.store.dispatch(new PatchDebug({ type: this.appConfig.typeProjet }));
      this.store.dispatch(new NavigatePageFormulaire());
    } else {
      console.error(`L'étape ${etape} n'existe pas`);
    }
  }

  allerPage(pageUrl: string) {
    console.log('TestHelper > preautorisation > allerPage', pageUrl);
    switch (pageUrl) {
      case 'resultat':
        this.store.selectSnapshot(PreautorisationSelectors.statutPreautorisation)
          ? this.store.dispatch(new NavigatePageResultat())
          : console.error("Impossible d'aller à la page résultat. La préautorisation n'existe pas");
        break;
      case 'non-eligible':
        this.store.dispatch(new GoToStep(1));
        this.store.dispatch(new NavigatePageNonEligible());
        break;
      case 'accueil':
        this.store.selectSnapshot(PreautorisationSelectors.statutPreautorisation)
          ? console.error("Impossible d'aller à la page d'accueil. La préautorisation est déjà complétée")
          : this.store.dispatch(new NavigatePageAccueil());
        break;
      default:
        console.error('Page invalide');
    }
  }

  private getIdConsentement() {
    return new DonneReferenceService(this.appConfig).getConsentText(this.appConfig.typeProjet).id;
  }

  async chargerDonnees(data: Partial<PreautorisationModel>) {
    console.log('TestHelper > preautorisation > chargerDonnees', data);
    this.store.dispatch(new PatchDebug({ ...data, type: this.appConfig.typeProjet }));
    this.store.dispatch(new SaveEtapeConsentement(this.getIdConsentement()));

    const previousCurrentStep = this.store.selectSnapshot(PreautorisationSelectors.currentStep);
    await this.store.dispatch(new ValiderPreadmissibilite()).toPromise();
    this.store.dispatch(new GoToStep(previousCurrentStep));
    if (previousCurrentStep) {
      this.store.dispatch(new NavigatePageFormulaire());
    }
  }

  setupBackend(data: Partial<PreautorisationModel>) {
    console.log('TestHelper > preautorisation > setupBackend', data);

    if (this.store.selectSnapshot(PreautorisationSelectors.statutPreautorisation)) {
      console.error('Impossible de soumettre une préautorisation. La préautorisation est déjà complétée');
      return;
    }

    this.store.dispatch(new SaveEtapeConsentement(this.getIdConsentement()));
    this.store.dispatch(new ValiderPreadmissibilite());
    this.store.dispatch(new PatchDebug(data));
    this.store.dispatch(new Submit());
    console.log(
      'La préautorisation a été soumise et a un statut',
      this.store.selectSnapshot(PreautorisationSelectors.statutPreautorisation)
    );
  }
}
